// src/pages/buyer/ReferralsPage.jsx
import { useQuery } from '@tanstack/react-query'
import { Users, Copy, Share2 } from 'lucide-react'
import { referralsApi } from '../../api/services'
import { Card, CardBody, Button, PageSpinner } from '../../components/common/ui'
import toast from 'react-hot-toast'

export default function ReferralsPage() {
  const { data, isLoading } = useQuery({ queryKey: ['referrals'], queryFn: () => referralsApi.stats() })
  if (isLoading) return <PageSpinner />
  const stats = data?.data?.data || {}
  const code = stats.code || stats.referral_code || '—'
  const url = `${window.location.origin}/register?ref=${code}`

  const copy = () => { navigator.clipboard.writeText(url); toast.success('Link copied!') }

  return (
    <div>
      <h1 className="text-xl font-display font-bold mb-6 flex items-center gap-2"><Users size={20} className="text-pink" /> Referrals</h1>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        {[
          { label: 'Your Code', value: code },
          { label: 'Invited', value: stats.total_referrals ?? 0 },
          { label: 'Converted', value: stats.converted ?? 0 },
          { label: 'Points Earned', value: Number(stats.points_earned ?? 0).toLocaleString('en-IN') + ' pts' },
        ].map(({ label, value }) => (
          <div key={label} className="bg-white border border-border rounded-xl p-4 text-center">
            <p className="text-lg font-bold text-gray-900">{value}</p>
            <p className="text-xs text-muted mt-0.5">{label}</p>
          </div>
        ))}
      </div>

      <Card className="mb-4">
        <CardBody>
          <p className="text-sm font-bold mb-2">Share Your Link</p>
          <div className="flex gap-2">
            <input readOnly value={url} className="input flex-1 text-xs" />
            <Button variant="secondary" size="sm" onClick={copy}><Copy size={14} /></Button>
          </div>
        </CardBody>
      </Card>

      {stats.referred_users?.length > 0 && (
        <Card>
          <CardBody>
            <p className="text-sm font-bold mb-3">People You Referred</p>
            <div className="space-y-2">
              {stats.referred_users.map((u, i) => (
                <div key={i} className="flex items-center justify-between text-sm">
                  <span>{u.name || u.email}</span>
                  <span className="text-xs text-muted">{new Date(u.joined_at || u.created_at).toLocaleDateString('en-IN')}</span>
                </div>
              ))}
            </div>
          </CardBody>
        </Card>
      )}
    </div>
  )
}
